import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CallTranscriptIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "CallTranscript",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M27.19 10.56a1.3 1.3 0 0 0-.13-.35s0-.07 0-.07c-.06-.11-.13-.21-.22-.3l-7.52-7.5c-.09-.09-.19-.16-.3-.22s-.08 0-.08 0c-.08-.04-.17-.08-.26-.1H8.97c-2.3 0-4.17 1.85-4.21 4.15v20.11c0 2.2 1.73 3.74 4.21 3.74H23c2.47 0 4.21-1.54 4.21-3.74V10.57h-.03Zm-2.82 15.7c0 .77-.77.97-1.4.97H8.98c-.64 0-1.4-.17-1.4-.97V6.15c0-.77.63-1.4 1.4-1.4h7.95v5.14c0 1.3 1.04 2.34 2.33 2.34h5.11zM11.05 14.1l.65-.66c.17-.16.4-.26.66-.26s.49.1.66.26 1.74 1.75 1.74 1.75c.17.17.28.4.28.66s-.11.49-.28.66l-1.28 1.29a.604.604 0 0 0 0 .86l2.62 2.63a.63.63 0 0 0 .88 0L18.27 20c.16-.17.4-.28.65-.28s.49.11.65.28l1.75 1.74c.16.17.26.4.26.66s-.1.49-.26.66l-.66.7c-.53.44-1.22.7-1.97.7a3 3 0 0 1-1.16-.23h.02c-.48-.14-.88-.3-1.27-.5l.04.02c-1.2-.59-2.22-1.33-3.1-2.22-.89-.88-1.64-1.9-2.19-3.03l-.03-.07c-.09-.19-.17-.38-.23-.56-.58-1.55-.55-2.92.27-3.77Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M12.14 29.29H5.28c-1.89 0-3.43-1.54-3.43-3.43V5.29c0-1.89 1.54-3.43 3.43-3.43h13.71c.3 0 .59.12.81.33l9.14 9.14c.45.45.45 1.17 0 1.62s-1.17.45-1.62 0l-8.81-8.81H5.29c-.63 0-1.14.51-1.14 1.14v20.57c0 .63.51 1.14 1.14 1.14h6.86a1.14 1.14 0 1 1 0 2.28Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M28.14 13.29h-6.86c-1.89 0-3.43-1.54-3.43-3.43V3a1.14 1.14 0 1 1 2.28 0v6.86c0 .63.51 1.14 1.14 1.14h6.86a1.14 1.14 0 1 1 0 2.28ZM27.38 21.2l-2.45-2.45 2.03-2.03.28.28a3.09 3.09 0 0 1 0 4.36L24.3 24.3l-2.94 2.94a3.09 3.09 0 0 1-4.36 0l-.28-.28 2.03-2.03 2.45 2.45"
      }), /*#__PURE__*/_jsx("path", {
        d: "M19.18 29.28c-1.13 0-2.19-.44-2.99-1.24l-.28-.28c-.21-.21-.34-.51-.34-.81s.12-.59.33-.81l2.04-2.04a1.14 1.14 0 0 1 1.62 0l1.66 1.66 4.55-4.55-1.66-1.66a1.14 1.14 0 0 1 0-1.62l2.04-2.04a1.14 1.14 0 0 1 1.62 0l.28.28a4.23 4.23 0 0 1 0 5.98l-5.88 5.88c-.8.8-1.86 1.24-2.99 1.24Zm-.74-2.43c.24.1.51.15.78.15l-.46-.46-.31.31Zm8.1-8.1.46.46c0-.26-.04-.53-.15-.78l-.31.31Z"
      })]
    })
  }));
};
CallTranscriptIcon.displayName = 'CallTranscriptIcon';